import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import SelectGoalTree from './SelectGoalTree/SelectGoalTree.container';
import Icon from './Icon';

const InputGroupMultiselect = ({ tags, nesting, onChange }) => {
    const [state, setState] = useState({
        modalIsVisible: false,
        tags: tags || []
    });

    const initTags = Array.isArray(tags) && tags.length > 0;

    const getArrayIds = useCallback((array = state.tags) => {
        return array.map(item => item.id || item.value);
    }, [state.tags]);

    const toggleModal = useCallback((event) => {
        if (event && event.target.nodeName !== 'UL') {
            return;
        }

        setState(prev => ({
            ...prev,
            modalIsVisible: !prev.modalIsVisible
        }));
    }, []);

    const onInitTags = useCallback((items) => {
        setState(prev => ({
            ...prev,
            tags: items
        }));
    }, []);

    const onDeleteTag = useCallback((event) => {
        let tags = [...state.tags];
        let index = event.target.getAttribute('data-index');

        tags.splice(index, 1);

        setState(prev => ({
            ...prev,
            tags
        }));
        
        const ids = tags.map(item => item.id || item.value);
        onChange && onChange(ids);
    }, [state.tags, onChange]);

    const onAddTags = useCallback((items) => {
        let tags = [...state.tags].concat(items);

        setState(prev => ({
            ...prev,
            tags
        }));
        
        const ids = tags.map(item => item.id || item.value);
        onChange && onChange(ids);
    }, [state.tags, onChange]);

    return (
        <div className="input-group-multiselect">
            <ul
                className="input-group-multiselect-taglist"
                onClick={toggleModal}
            >
                {state.tags.map((item, i) => (
                    <li className="input-group-multiselect-tag" key={item.value || i}>
                        {item.title || item.value}
                        <Icon name={'fa-close input-group-multiselect-close'}
                            data-index={i}
                            onClick={onDeleteTag}
                        />
                    </li>
                ))}
                <li className="input-group-multiselect-tag input-group-multiselect-tag_input" />
            </ul>
            <SelectGoalTree
                initGoalActions={initTags ? {
                    ids: getArrayIds(Array.isArray(tags) ? tags : []).join(','),
                    onSuccess: onInitTags
                } : null}
                modalIsVisible={state.modalIsVisible}
                nesting={nesting}
                blockedIdGoalActions={getArrayIds()}
                onCloseModal={toggleModal}
                onConfirm={onAddTags}
            />
        </div>
    );
};

InputGroupMultiselect.propTypes = {
    tags: PropTypes.array,
    nesting: PropTypes.string,
    onChange: PropTypes.func
};

InputGroupMultiselect.defaultProps = {
    tags: [],
    nesting: '',
    onChange: () => {}
};

export default InputGroupMultiselect;
